import { useBooleanState } from '@cian/react-utils';
import { Button, TooltipDesktop } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, useCallback } from 'react';

import { Switcher } from '../Switcher';

interface INarrowListToggleButtonProps {
  viewMode: 'map' | 'hybrid';
  onToggle: VoidFunction;
}

export const NarrowListToggleButton: FC<INarrowListToggleButtonProps> = ({ viewMode, onToggle }) => {
  const isHybridMode = viewMode === 'hybrid';

  const IconChevron16 = isHybridMode ? IconActionChevronLeft16 : IconActionChevronRight16;

  const tooltipTitle = isHybridMode ? 'Свернуть' : 'Показать';

  const { state: isTooltipOpen, setTrue: setTooltipOpen, setFalse: setTooltipClosed } = useBooleanState(false);

  const handleToggle = useCallback(() => {
    onToggle();
    setTooltipClosed();
  }, [onToggle, setTooltipClosed]);

  return (
    <TooltipDesktop open={isTooltipOpen} placement={isHybridMode ? 'left' : 'bottom'} title={tooltipTitle}>
      <Switcher>
        <Button
          beforeIcon={<IconChevron16 color="icon-main-default" />}
          data-testid="view-mode-controls.map-mode-switcher"
          size="M"
          theme="fill_white_primary"
          onClick={handleToggle}
          onMouseEnter={setTooltipOpen}
          onMouseLeave={setTooltipClosed}
        />
      </Switcher>
    </TooltipDesktop>
  );
};
